module.exports = __webpack_public_path__ + "static/media/new-order.048ec00a.svg";